const TOKEN_KEY = 'lhai_token';

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}

export function logout() {
  setToken(null);
  window.location.href = '/crm/login';
}

async function request(path, options = {}) {
  const headers = { 'Content-Type': 'application/json', ...(options.headers || {}) };
  const token = getToken();
  if (token) headers.Authorization = `Bearer ${token}`;
  const res = await fetch(path, { ...options, headers });
  if (res.status === 401) {
    logout();
    throw new Error('unauthorized');
  }
  if (!res.ok) {
    let body = {};
    try { body = await res.json(); } catch {}
    throw new Error(body.error || `http_${res.status}`);
  }
  return res.json();
}

export const api = {
  // public
  submitLead: (payload) =>
    fetch('/api/leads', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(async r => {
      if (!r.ok) {
        let body = {};
        try { body = await r.json(); } catch {}
        throw new Error(body.error || 'submit_failed');
      }
      return r.json();
    }),

  // auth
  login: (email, password) => request('/api/auth/login', {
    method: 'POST',
    body: JSON.stringify({ email, password })
  }),
  me: () => request('/api/auth/me'),

  // leads
  listLeads: (params = {}) => {
    const qs = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => { if (v) qs.set(k, v); });
    return request(`/api/leads?${qs.toString()}`);
  },
  getLead: (id) => request(`/api/leads/${id}`),
  patchLead: (id, body) => request(`/api/leads/${id}`, { method: 'PATCH', body: JSON.stringify(body) }),
  recordCallAttempt: (id) => request(`/api/leads/${id}/call-attempt`, { method: 'POST' }),
  deleteLead: (id) => request(`/api/leads/${id}`, { method: 'DELETE' }),
  exportCSV: async () => {
    const res = await fetch('/api/leads/export.csv', {
      headers: { Authorization: `Bearer ${getToken()}` }
    });
    if (res.status === 401) { logout(); throw new Error('unauthorized'); }
    if (res.status === 403) throw new Error('forbidden');
    if (!res.ok) throw new Error('export_failed');
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `lhai-leads-${new Date().toISOString().slice(0, 10)}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  },
  stats: () => request('/api/leads/stats'),
  config: () => request('/api/config')
};
